// extracted by mini-css-extract-plugin
var _1 = "Rm6U3WM0";
var _2 = "UNqtyBo7";
export { _1 as "active", _2 as "dropdownItem" }
